import { defineComponent as _defineComponent } from 'vue'
import PaymentListing from 'ah-payments/src/components/PaymentListing.vue';
import ActivityPaymentsListFilters from './ActivityPaymentsListFilters.vue';
import ListBlock from 'ah-common-lib/src/common/components/listing/ListBlock.vue';
import ListDownloadButton from 'ah-common-lib/src/common/components/listing/ListDownloadButton.vue';
import { ExportListType, PaginatedParams } from 'ah-api-gateways';
import { computed, reactive, ref } from 'vue';
import { adminPaymentsTableFields } from './tableFields/paymentsTableFields';
import { RequestState } from 'ah-requests';
import SizeSelector from 'ah-common-lib/src/common/components/SizeSelector.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityPaymentsListBlock',
  props: {
    showExport: { type: [Boolean, String], default: true }
  },
  setup(__props: any) {



const paymentListing = ref<InstanceType<typeof PaymentListing> | null>(null);

const state = reactive<{
  // Automatically syncronised via .sync
  dataDownloadState: RequestState;
  pageAndSortParams: Partial<PaginatedParams>;
}>({
  dataDownloadState: 'idle',
  pageAndSortParams: { sort: 'createdAt', sortDirection: 'DESC' },
});

const config = computed(() => {
  return {
    tableFields: adminPaymentsTableFields,
  };
});

function downloadList(format: ExportListType, options: { [key: string]: any }) {
  paymentListing.value?.downloadData(format, options);
}

const pageOptions = ref([
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
]);

return { __sfc: true,paymentListing, state, config, downloadList, pageOptions, PaymentListing, ActivityPaymentsListFilters, ListBlock, ListDownloadButton, SizeSelector }
}

})